<template>
  <component
    :is="component"
    :content
    inline
    :options="component === CmsRichTextAdvanced ? dynamicFields : undefined"
  />
</template>

<script lang="ts" setup>
import { CmsRichTextAdvanced, CmsRichTextStandard } from '#components'
import { DynamicFieldsKey } from '#content/contexts/dynamic-fields'

const { content } = defineProps<{ content: string }>()

const dynamicFields = inject(DynamicFieldsKey, undefined)

const component = dynamicFields && content.includes('data-component') ? CmsRichTextAdvanced : CmsRichTextStandard
</script>
